<template>
  <div v-if="!lobbyMyTeamId" class="pravo-sirsi__lobby">
    <div class="pravo-sirsi__lobby__search">
      <ValidationObserver v-slot="{ handleSubmit, failed }" tag="div">
        <ValidationProvider rules="required" v-slot="{ failed }">
          <input
            v-model="teamName"
            type="text"
            placeholder="Name of the new team"
            class="pravo-sirsi__lobby__search__input input"
            :class="{ error: failed }"
            @keydown.enter="handleSubmit(createTeam)"
          />
        </ValidationProvider>
        <button
          class="pravo-sirsi__lobby__search__button2 button"
          :disabled="failed"
          @click="handleSubmit(createTeam)"
        >
          Add and join a new team
        </button>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Search",
  data() {
    return {
      teamName: "",
      isLoading: false,
    };
  },
  methods: {
    async createTeam() {
      const result = await this.$store.dispatch("createTeam", this.teamName);
      if (result) {
        this.teamName = "";
      }
    },
  },
  computed: {
    ...mapGetters(["lobbyMyTeamId"]),
  },
};
</script>
